import React from "react"

interface iModal {
  children: any
  show: boolean
  onClose: () => void
}

interface iModalView {
  children: any
  onClose: () => void
}

const ModalView: React.FC<iModalView> = ({ children, onClose }) => {
  return (
    <div className="fixed top-0 bottom-0 z-30 h-screen w-screen">
      <div className="flex relative  items-center justify-center h-full w-full">
        <div
          onClick={onClose}
          className="absolute top-0 left-0 h-full w-full"
          style={{ background: "rgba(17, 24, 39, 0.5)" }}
        />
        <div className="z-10">{children}</div>
      </div>
    </div>
  )
}

const Modal: React.FC<iModal> = ({ children, onClose, show }) => {
  if (!show) return null
  return <ModalView onClose={onClose}>{children}</ModalView>
}

export default Modal
